import { CREDENTIAL_CLASS_NAME } from 'models/daos/credential/constants'

const CREDENTIAL_KEY = {
  CLASS_NAME: 'className',
  EMAIL: 'email',
  PASSWORD: 'password',
  IS_SIGNIN: 'isSignin',
  TOKEN: 'token',
  NEW_PASSWORD: 'newPassword',
  CONFIRM_NEW_PASSWORD: 'confirmNewPassword'
}

const CREDENTIAL_DOMAIN = 'credential'
const CREDENTIAL_STATE = {
  data: {
    [CREDENTIAL_KEY.CLASS_NAME]: CREDENTIAL_CLASS_NAME
  },
  className: CREDENTIAL_CLASS_NAME,
  status: null,
  validation: null,
  error: null,
  changed: {}
}

const CREDENTIAL_PLACEHOLDER = {
  [CREDENTIAL_KEY.EMAIL]: 'yourname@example.com',
  [CREDENTIAL_KEY.PASSWORD]: 'yourpassword',
  [CREDENTIAL_KEY.NEW_PASSWORD]: 'Your new password',
  [CREDENTIAL_KEY.CONFIRM_NEW_PASSWORD]: 'Confirm your new password'
}

const CREDENTIAL_VALIDATOR = {
  [CREDENTIAL_KEY.PASSWORD]: [
    6,
    60
  ]
}

export {
  CREDENTIAL_KEY,
  CREDENTIAL_DOMAIN,
  CREDENTIAL_STATE,
  CREDENTIAL_PLACEHOLDER,
  CREDENTIAL_VALIDATOR
}
